import React from 'react';
import { bookingShape, historyDetailShape } from 'constants/propTypes';

import PropTypes from 'prop-types';
import { ActionItemTicket, ActionItemTicketCell } from './HistoryDetail.styles';
import HistoryActionPassengerId from './HistoryActionPassengerId';
import { getBookingPassengerForHistoryTicket } from './HistoryDetails.utils';

const HistoryActionTicket = ({ action, booking, detail }) => (
  <ActionItemTicket>
    {detail.data.tickets
      .filter((t) => detail.revisionContents[action].includes(t.uuid))
      .map((t) => (
        <React.Fragment key={t.uuid}>
          <ActionItemTicketCell>
            <HistoryActionPassengerId passenger={getBookingPassengerForHistoryTicket(booking, t)} />
          </ActionItemTicketCell>
          <ActionItemTicketCell>{t.ticketNo}</ActionItemTicketCell>
          <ActionItemTicketCell>{t.location}</ActionItemTicketCell>
          <ActionItemTicketCell>{t.validationType}</ActionItemTicketCell>
        </React.Fragment>
      ))}
  </ActionItemTicket>
);

HistoryActionTicket.propTypes = {
  action: PropTypes.string.isRequired,
  booking: bookingShape,
  detail: historyDetailShape.isRequired
};

export default HistoryActionTicket;
